<template>
  <div>
    <graph
      :title="adminText('workflowsAll.visitors_by_location_201b261', 'Visitors by location')"
      :data-filter="true"
      :has-data="hasData"
      :value="
        data.primaryCity != null
          ? adminText('workflowsAll.city_share', '{{percent}}% from {{location}}', { percent: Math.round(data.primaryCityPercentage), location: data.primaryCity })
          : ''
      "
      :initial-date-range-option="initialDateRangeOption"
      :initial-date-range="initialDateRange"
      @changeDateRange="changeDateRange($event)"
    >
      <bar-chart :data="workflowUi(data)" :options="workflowUi({ indexAxis: 'y', barThickness: 35 })" />
    </graph>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { GET_EVENT_VISITOR_CITY_STATS } from '../../../graphql/purchase.graphql'

import BarChart from '../../shared/graphs/bar-chart.vue'
import Graph from '../../shared/graphs/graph.vue'
import moment from 'moment'
export default {
  mixins: [WorkflowDisplay],
  name: 'visitors-by-city-graph',
  components: {
    BarChart,
    Graph,
  },
  props: ['eventId', 'initialDateRangeOption', 'initialDateRange', 'eventTemplateId'],

  data() {
    return {
      data: { datasets: [{ data: [] }] },
      endDate: this.initialDateRange[1],
      startDate: this.initialDateRange[0],
    }
  },
  computed: {
    hasData() {
      return this.data.datasets[0].data.length > 0
    },
  },

  methods: {
    changeDateRange(dateRangeObject) {
      this.startDate = moment(dateRangeObject.dateRange[0]).format('YYYY-MM-DD')
      this.endDate = moment(dateRangeObject.dateRange[1]).format('YYYY-MM-DD')
      this.filterByDate()
    },
    async filterByDate() {
      await this.$apollo.queries.getEventVisitorCityStats.refetch()
    },
  },
  apollo: {
    getEventVisitorCityStats: {
      query: GET_EVENT_VISITOR_CITY_STATS,
      variables() {
        return {
          from: this.startDate,
          to: this.endDate,
          eventId: this.eventId,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ loading, data }) {
        if (!loading) {
          const {
            getEventVisitorCityStats: { cities, ...rest },
          } = data
          this.data = {
            ...rest,
            labels: cities.map(e => e.name),
            datasets: [{ data: cities.map(e => e.total) }],
          }
        }
      },
    },
  },
}
</script>

<style scoped></style>
